var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExternalLink = function SvgExternalLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.813 2.125H3.188c-.739 0-1.313.602-1.313 1.313v9.625c0 .738.574 1.312 1.313 1.312h9.625c.71 0 1.312-.574 1.312-1.312V3.438c0-.711-.602-1.313-1.312-1.313zm-.165 10.938H3.352c-.11 0-.164-.055-.164-.165V3.602c0-.082.054-.164.164-.164h9.296c.082 0 .165.082.165.164v9.296c0 .11-.083.165-.165.165zM11.172 4.75H7.453c-.301 0-.465.355-.246.574L8.52 6.637l-3.938 3.937c-.137.137-.137.356 0 .465l.629.629c.109.137.328.137.465 0L9.613 7.73l1.313 1.313c.219.191.574.055.574-.246V5.078a.353.353 0 00-.328-.328z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExternalLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/external-link.72d706ab.svg";
export { ForwardRef as ReactComponent };